import { Navigate, Route, Routes } from 'react-router-dom'
import { CreateAdminAccountPage, LoginPage, ResetPassword } from 'Containers'

const LoginRouter = () => {
  return (
    <div>
      <Routes>
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/createAccount/*" element={<CreateAdminAccountPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  )
}

export default LoginRouter
